type Params = {
    isPaidPlan: boolean;
    isEmailVerified: boolean;
    isOnEmailUnverified: boolean;
    isExempt: boolean;
};

export type EmailVerificationGateRedirect = '/email-unverified' | '/dashboard';

export function resolveEmailVerificationGate({
    isPaidPlan,
    isEmailVerified,
    isOnEmailUnverified,
    isExempt,
}: Params): EmailVerificationGateRedirect | null {
    if (isPaidPlan && !isEmailVerified && !isExempt) {
        return isOnEmailUnverified ? null : '/email-unverified';
    }
    return isOnEmailUnverified ? '/dashboard' : null;
}
